import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import Hero from '../components/sections/Hero';
import LogoMarquee from '../components/sections/LogoMarquee';
import Stats from '../components/sections/Stats';
import Services from '../components/sections/Services';
import CaseStudies from '../components/sections/CaseStudies';
import Creators from '../components/sections/Creators';
import Process from '../components/sections/Process';
import Testimonials from '../components/sections/Testimonials';
import FAQ from '../components/sections/FAQ';
import DualCTA from '../components/sections/DualCTA';
import Contact from '../components/sections/Contact';
import StickyCTA from '../components/ui/StickyCTA';

const Home = () => {
  const location = useLocation();

  // Support /#section deep links
  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      }, 120);
    }
  }, [location]);

  return (
    <>
      <>
        <title>ThirdRail Avenue — Gaming Influencer Marketing Agency</title>
        <meta
          name="description"
          content="ThirdRail Avenue is a creator-first gaming influencer marketing agency. We connect brands with 4M+ engaged players through authentic partnerships that drive ROI."
        />
      </>

      <Navbar />
      <main id="main-content">
        <Hero />
        <LogoMarquee />
        <CaseStudies />
        <Services />
        <Creators />
        <Stats />
        <Process />
        <Testimonials />
        <FAQ />
        <DualCTA />
        <Contact />
      </main>
      <Footer />
      <StickyCTA />
    </>
  );
};

export default Home;
